"use strict";
import { getAuthData } from "../../storage/LocalStorage";

const AUTH_PROVIDERS = {
  google: "google",
  frontm: "FrontM",
};

class AuthError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
  }
};

class Auth {
  constructor() {
    this.login = (provider, conversationId, botName) =>
      new Promise((resolve, reject) => {
        if (!AUTH_PROVIDERS[provider]) {
          return reject(`Invalid provider. Not supported: ${provider}`);
        }
        provider === AUTH_PROVIDERS.google
          ? resolve(this.loginWithGoogle(conversationId, botName))
          : reject(`Not supported right now: ${provider}`);
      });

    this.loginWithGoogle = (conversationId, botName) =>
      new Promise((resolve) => resolve({}));

    this.loginWithFrontm = (userDetails, conversationId, botName) =>
      new Promise((resolve) => resolve({}));

    this.setDomains = (domains) => new Promise((resolve) => resolve());

    this.deleteUser = () => new Promise((resolve) => resolve());

    this.logout = (argAppType = 'onecare') =>
      new Promise((resolve) => resolve());

    this.saveUser = (user) =>
      new Promise((resolve, reject) => {
        if (!user) return reject("Valid user object required");
        resolve();
      });

    this.getUser = () =>
      new Promise((resolve) => {
        const userDetail = getAuthData();
        resolve({
          creds: userDetail.auth,
          info: userDetail.user,
          provider: {
            lastRefreshTime: userDetail.stored_at,
            name: "tseting",
          },
          userId: userDetail.user.userId,
        });
      });

    this.isUserLoggedIn = () => new Promise((resolve) => resolve(true));

    this.updateUserDetails = (details) =>
      new Promise((resolve) => resolve({}));

    this.addDomains = (domains) =>
      new Promise((resolve) => resolve({}));

    this.updatePassword = (payload) =>
      new Promise((resolve) => resolve({}));

    this.refresh = (user) =>
      new Promise((resolve) => resolve({}));

    this.setUserSetting = (key, value) =>
      new Promise((resolve) => resolve(true));

    this.getUserSetting = (key, defaultValue = undefined) =>
      new Promise((resolve) => resolve(true));

    this.authProviders = () => AUTH_PROVIDERS;
  }
}

const AuthErrorCodes = {
  0: "User cancelled",
  1: "Error in saving Auth Session",
  2: "Logout Error",
  98: "Custom Error",
  99: "Unknown error",
};

export { AuthError, AUTH_PROVIDERS, Auth, AuthErrorCodes };
